module.exports = __webpack_public_path__ + "static/media/ehealth_calculator_banner_desktop.197ae8b5.jpg";